import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { KeyRound, Loader2, ArrowLeft } from "lucide-react";

import TopNav from "@/components/TopNav";
import CompanyLlmKeysPanel from "@/components/company/CompanyLlmKeysPanel";
import { listCompanyAgents } from "@/lib/api";
import { useMyCompany, canSeeKeys } from "@/hooks/useMyCompany";
import { TokenAlertsBanner } from "@/components/company/CompanyUi";

const NOT_ALLOWED = "La configuración de claves de IA de su empresa la administra Inviktus. Solo el usuario master puede verla cuando Inviktus la habilita.";

export default function MyCompanyKeys() {
  const { data, loading, refresh } = useMyCompany();
  const [checked, setChecked] = useState(false);
  const [agents, setAgents] = useState(null);

  useEffect(() => {
    refresh().finally(() => setChecked(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const allowed = canSeeKeys(data);
  const slug = data?.company?.slug;
  useEffect(() => {
    if (!allowed || !slug) return;
    listCompanyAgents(slug).then((d) => setAgents(d.agents || [])).catch(() => setAgents([]));
  }, [allowed, slug]);

  if (!checked || (loading && !data)) {
    return (
      <div className="min-h-screen bg-white"><TopNav />
        <div className="flex items-center justify-center py-32 text-slate-500"><Loader2 className="mr-2 h-5 w-5 animate-spin" /> Cargando…</div>
      </div>
    );
  }
  if (!allowed) return <Navigate to="/mi-empresa" replace state={{ notice: NOT_ALLOWED }} />;

  return (
    <div className="min-h-screen bg-white text-ink" data-testid="my-company-keys-page">
      <TopNav />
      <div className="mx-auto max-w-6xl px-6 py-12">
        <Link to="/mi-empresa" className="inline-flex items-center gap-1 text-[11px] uppercase tracking-[0.18em] text-slate-500 hover:text-ink"
              data-testid="back-to-my-company">
          <ArrowLeft className="h-3 w-3" /> Mi empresa
        </Link>
        <p className="eyebrow mt-4 flex items-center gap-1.5"><KeyRound className="h-3 w-3" /> {data.company.name} · Claves de IA</p>
        <h1 className="mt-2 font-display text-4xl text-ink">Claves, modelos y límites mensuales</h1>
        <p className="mt-3 max-w-3xl text-sm text-slate-600">
          Configure la clave genérica de su empresa y, si lo desea, una clave propia por agente. Cada clave tiene un límite
          mensual de tokens obligatorio; al alcanzarlo, el agente pasa a la siguiente clave o queda bloqueado.
        </p>
        <TokenAlertsBanner level={data.token_alert_level} alerts={data.token_alerts} />
        <div className="mt-8">
          {agents === null ? (
            <div className="flex items-center gap-2 text-sm text-slate-500"><Loader2 className="h-4 w-4 animate-spin" /> Cargando…</div>
          ) : (
            <CompanyLlmKeysPanel slug={slug} agents={agents} forClient onChanged={refresh} />
          )}
        </div>
      </div>
    </div>
  );
}
